import "./App.css";
import { ToastContainer } from "react-toastify";

import { CssBaseline, ThemeProvider } from "@mui/material";

import RouteLayout from "./routes";
import theme from "./theme/theme";

import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouteLayout />
        <ToastContainer position="top-right" autoClose={5000} />
      </ThemeProvider>
    </div>
  );
};

export default App;
